import { useAuthQuery } from '../auth/hooks/useAuthQuery';
import { useToastStore } from '../shared/stores/toastStore';

type SmsConfirmationType = 'created' | 'updated' | 'canceled';

interface UseSmsConfirmation {
  handleShowSmsConfirmationToast: (isSeries: boolean, type: SmsConfirmationType) => void;
  smsConfirmationMessage: string;
}

const SMS_CONFIRMATION_MESSAGE = 'Caregivers and riders will be notified via SMS.';

export const useSmsConfirmation = (): UseSmsConfirmation => {
  const { addToast } = useToastStore();
  const { userSettings } = useAuthQuery();

  const shouldShowConfirmationMessage = userSettings?.messagingUpdatesRidersCaregivers === 'Yes';

  const handleShowSmsConfirmationToast = (isSeries: boolean, type: SmsConfirmationType) => {
    if (shouldShowConfirmationMessage) {
      addToast({
        severity: 'success',
        message: `${isSeries ? 'Ride Series' : 'Ride'} ${type}. ${SMS_CONFIRMATION_MESSAGE}`,
      });
    }
  };

  return {
    handleShowSmsConfirmationToast,
    smsConfirmationMessage: shouldShowConfirmationMessage ? SMS_CONFIRMATION_MESSAGE : '',
  };
};
